<div class="content">
  <app-advanced-filters #advancedFilters (loadData)="applyFilters($event)"
    (topValue)="updateTopValue($event)"></app-advanced-filters>
  <div class="container" [style.top.px]="containerTopValue" [style.height]="calcContainerHeight()" *ngIf="showTable">
    <div class="table-container mat-elevation-z3">

      <table mat-table class="documents" [dataSource]="items" matSort matSortActive="printedDate" matSortDirection="desc"
        matSortDisableClear [matSortDirection]="sortDirection" [matSortActive]="sortColumn"
        (matSortChange)="onSortData($event)">

        <ng-container matColumnDef="selection">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox [checked]="allSelected" [indeterminate]="indeterminate" (change)="onSelectAllChange($event)"
              matTooltip="{{'common.select-all' | translate}}"></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-checkbox [checked]="element.selected" (change)="onCheckboxChange(element, $event)"></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="shop">
          <th mat-header-cell *matHeaderCellDef> {{'common.shop' | translate}} </th>
          <td mat-cell *matCellDef="let element"> 
            <span>{{element.shop.shopNumber}}</span><br/>
            <span class="second-row">{{element.shop.shopName}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="printer">
          <th mat-header-cell *matHeaderCellDef> {{'common.printer' | translate}} </th>
          <td mat-cell *matCellDef="let element">
            <span>{{element.printer.uniqueNumber}}</span><br/>
            <span class="second-row">{{element.printer.name}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="documentNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'common.document-number' | translate}} </th>
          <td mat-cell *matCellDef="let element"> {{element.documentNumber}} </td>
        </ng-container>

        <ng-container matColumnDef="fiscalNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'documents.daily-reports.daily-report-number' |
            translate}} </th>
          <td mat-cell *matCellDef="let element"> {{element.fiscalNumber}} </td>
        </ng-container>

        <ng-container matColumnDef="salesStartDate">
          <th mat-header-cell *matHeaderCellDef> {{'documents.daily-reports.sales-start-date' | translate}} </th>
          <td mat-cell *matCellDef="let element"> {{element.salesStartDate | date:"yyyy-MM-dd HH:mm"}} </td>
        </ng-container>

        <ng-container matColumnDef="salesFinishDate">
          <th mat-header-cell *matHeaderCellDef> {{'documents.daily-reports.sales-finish-date' | translate}} </th>
          <td mat-cell *matCellDef="let element"> {{element.salesFinishDate | date:"yyyy-MM-dd HH:mm"}} </td>
        </ng-container>

        <ng-container matColumnDef="printedDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'common.printed-date' | translate}} </th>
          <td mat-cell *matCellDef="let element"> {{element.printedDate | date:"yyyy-MM-dd HH:mm"}} </td>
        </ng-container>

        <ng-container matColumnDef="vatAmount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'documents.daily-reports.vat-amount' | translate}}
          </th>
          <td mat-cell *matCellDef="let element"> {{element.vatAmount | currency: 'PLN '}} </td>
        </ng-container>

        <ng-container matColumnDef="grossAmount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'documents.daily-reports.gross-amount' | translate}}
          </th>
          <td mat-cell *matCellDef="let element"> {{element.grossAmount | currency: 'PLN '}} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> {{'common.actions' | translate}} </th>
          <td mat-cell *matCellDef="let element;">
            <div class="row">
              <button mat-mini-fab color="primary" aria-label="Preview" (click)="previewOpenDialog(element)">
                <fa-icon [icon]="faPreview"></fa-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" 
          (dblclick)="onRowDoubleClick(row)" [attr.id]="'row_' + row.id"
          [class.active]="currentPreview(row.fileId)"></tr>

      </table>

      <div class="empty-results" *ngIf="items.length === 0">{{'common.empty-results' | translate}}
      </div>

      <mat-paginator [length]="totalRows" [pageSize]="pageSize" [pageIndex]="pageIndex" color="primary"
        [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = $event; onPaginateChange($event)" showFirstLastButtons
        class="mat-paginator-row">
      </mat-paginator>
    </div>
  </div>
</div>